// Types
export type * from './types';

// Components
export { ThemeRenderer } from './ThemeRenderer';
export { ThemeErrorBoundary } from './ErrorBoundary';

// Tokens
export * from './tokens';

// Area Pages - Types
export type {
  CoastalRegion,
  AreaData,
  AreaSEO,
  AreaWeatherData,
  AreaAttraction,
  AreaAttractionsData,
  AreaWikiData,
  AreaMarketStats,
  AreaPageData,
  AreaProperty,
  AreaRegionGroup,
  AreaHeroProps,
  AreaOverviewProps,
  AreaMapProps,
  AreaStatsProps,
  AreaAttractionsProps,
  AreaPropertiesProps,
  AreaSelectorProps,
  AreaPageProps,
  AreaPageMessages,
} from './area-types';

// Area Pages - Data
export {
  MAURITIUS_REGIONS,
  AREA_LOOKUP,
  MAURITIUS_AREAS,
  getAreaBySlug,
  getAreasByRegion,
  getAllAreaSlugs,
  getNearbyAreas,
} from './area-data-mauritius';

// Area Pages - Services
export {
  fetchAreaWeather,
  getCardinalDirection,
  fetchAreaWikiData,
  parseCoordinates,
  formatCoordinates,
  getDefaultMarketStats,
} from './area-services';